import {createDivIn, createExternalImgIn, createHeaderIn, createParagraphIn, setElementInnerHTML} from '../ui_utils/DomUtils'
import {CardDataController} from '@colonist/game-card-types'
import {getImagePath, logError} from '../ui_utils/Utils'
import {CardEnum} from '@colonist/game-states'
import {UIGameManager} from './UIGameManager'

export class GameChatDevCardHelp {
    private helpPopup: HTMLDivElement | undefined
    private helpPopupContents: HTMLDivElement | undefined
    private currentCard: CardEnum | undefined
    private readonly uiGameManager: UIGameManager

    constructor(uiGameManager: UIGameManager) {
        // eslint-disable-next-line no-restricted-syntax
        this.disablePopup = this.disablePopup.bind(this)
        this.uiGameManager = uiGameManager
    }

    private isPopupShown(): boolean {
        if(this.helpPopup == undefined) return false
        if(this.helpPopup?.parentElement == undefined) return false
        return true
    }

    private enablePopup(isChatEnabled: boolean, position: DOMRect) {
        this.helpPopup = createDivIn(document.body, 'chat_devcard_help_popup',)
        this.helpPopupContents = createDivIn(this.helpPopup, '')
        const canvas = this.uiGameManager.canvasController.app.view
        const gameLog = this.uiGameManager.chatController.getLogContainer()

        // Mar 9 2022 Mousetail
        // Note: I took care of the unbound method by using `this.disablePopup = this.disablePopup.bind(this)` in the constructor
        // It's necessary to do it there instead of here since this preserves equality which is needed for `removeEventListener` to work.
        // eslint-disable-next-line @typescript-eslint/unbound-method
        canvas.addEventListener('click', this.disablePopup)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        gameLog.addEventListener('click', this.disablePopup)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.helpPopup.addEventListener('click', this.disablePopup)

        if(isChatEnabled) return this.setPositionBasedOnChat(position)
        return this.setPositionBasedOnLog(position)
    }

    private setPositionBasedOnChat(position: DOMRect) {
        if(this.helpPopup == undefined) return

        this.helpPopup.style.left = position.left + 'px'
        this.helpPopup.style.top = position.top + 'px'
        this.helpPopup.style.width = position.width + 'px'
        this.helpPopup.style.height = position.height + 'px'
    }

    private setPositionBasedOnLog(position: DOMRect) {
        if(this.helpPopup == undefined) return

        this.helpPopup.style.left = position.left - position.width - 2 + 'px'
        this.helpPopup.style.top = position.top + 'px'
        this.helpPopup.style.width = position.width + 'px'
        this.helpPopup.style.height = position.height / 2 + 'px'

        this.helpPopup.classList.add('small')
    }

    disablePopup() {
        const canvas = this.uiGameManager.canvasController.app.view
        const gameLog = this.uiGameManager.chatController.getLogContainer()

        // Mar 9 2022 Mousetail
        // Same reasoning as at enablePopup
        // Taken care of in constructor
        // eslint-disable-next-line @typescript-eslint/unbound-method
        canvas.removeEventListener('click', this.disablePopup)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        gameLog.removeEventListener('click', this.disablePopup)
        // eslint-disable-next-line @typescript-eslint/unbound-method
        this.helpPopup?.removeEventListener('click', this.disablePopup)
        this.currentCard = undefined
        this.helpPopup?.parentElement?.removeChild(this.helpPopup)
    }

    private changePopup(type: CardEnum) {
        this.currentCard = type
        const cardData = CardDataController.getCardDataForCard(type)
        if(cardData === undefined) {
            logError('changePopup', [`Invalid help card enum: ${type}`])
            return
        }
        if(this.helpPopupContents !== undefined) {
            const {tipTitle, popupBody} = cardData
            setElementInnerHTML(this.helpPopupContents, {key: 'strings:colonistCommon.utils.emptyString'})
            createExternalImgIn(this.helpPopupContents, getImagePath(`${cardData.imageFileName}.svg`), tipTitle, 'float-left')
            createHeaderIn(this.helpPopupContents, tipTitle, '', undefined, 'h4')
            createParagraphIn(this.helpPopupContents, popupBody, '')
        }
    }

    showHelpPopup(popupType: CardEnum, isChatEnabled: boolean, size: DOMRect) {
        if(popupType === this.currentCard) {
            this.disablePopup()
            return
        }
        if(!this.isPopupShown()) this.enablePopup(isChatEnabled, size)
        this.changePopup(popupType)
    }
}
